import React from 'react'
import { Link } from 'react-router-dom'
import './AccessDeniedPage.css'

export const AccessDeniedPage: React.FC = () => {
  return (
    <div className="access-denied-page">
      <div className="access-denied-page__content">
        <div className="access-denied-page__icon">🚫</div>
        <h1>Access Denied</h1>
        <p>You don't have permission to access this page. Admin privileges are required.</p>
        <div className="access-denied-page__actions">
          <Link to="/dashboard" className="btn btn-primary">
            Go to Dashboard
          </Link>
        </div>
      </div>
    </div>
  )
}
